// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/auth.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Signed } from "./cert_pb";
import { file_luwu_v1_cert } from "./cert_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/auth.proto.
 */
export const file_luwu_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("ChJsdXd1L3YxL2F1dGgucHJvdG8SB2x1d3UudjEiYAoJQXV0aEhlbGxvEh0KBGNlcnQYASABKAsyDy5sdXd1LnYxLlNpZ25lZBIMCgRjYXBzGAIgAygJEhMKC2FwcF92ZXJzaW9uGAMgASgJEhEKCXByb3RvX3JldhgEIAEoDSKVAQoISG9zdEluZm8SEAoIaG9zdG5hbWUYASABKAkSCgoCb3MYAiABKAkSDAoEYXJjaBgDIAEoCRIPCgd2ZXJzaW9uGAQgASgJEhQKDHRtdXhfdmVyc2lvbhgFIAEoCRIQCghmZWF0dXJlcxgGIAMoCRIkCgZhZ2VudHMYByADKAsyFC5sdXd1LnYxLkFnZW50UHJlc2V0IlcKC0FnZW50UHJlc2V0EgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSEQoJYXZhaWxhYmxlGAMgASgIEg0KBWJhc2VkGAQgASgJEgwKBGNoYXQYBSABKAgijAEKCkF1dGhSZXN1bHQSCgoCb2sYASABKAgSDgoGcmVhc29uGAIgASgJEh4KFnBlbmRpbmdfbG9jYWxfYXBwcm92YWwYAyABKAgSIQoFaGVsbG8YBCABKAsyEi5sdXd1LnYxLkF1dGhIZWxsbxIfCgRob3N0GAUgASgLMhEubHV3dS52MS5Ib3N0SW5mb0IoWiZsdXd1LmRldi9nby9pbnRlcm5hbC9wYi9sdXd1L3YxO2x1d3V2MWIGcHJvdG8z", [file_luwu_v1_cert]);

/**
 * /luwu/auth/1.0.0 — the first stream on every connection. The dialer sends
 * AuthHello; the listener verifies it and answers with AuthResult carrying
 * its own AuthHello so the dialer can verify the listener too.
 *
 * @generated from message luwu.v1.AuthHello
 */
export type AuthHello = Message<"luwu.v1.AuthHello"> & {
  /**
   * @generated from field: luwu.v1.Signed cert = 1;
   */
  cert?: Signed | undefined;

  /**
   * @generated from field: repeated string caps = 2;
   */
  caps: string[];

  /**
   * @generated from field: string app_version = 3;
   */
  appVersion: string;

  /**
   * @generated from field: uint32 proto_rev = 4;
   */
  protoRev: number;
};

/**
 * Describes the message luwu.v1.AuthHello.
 * Use `create(AuthHelloSchema)` to create a new message.
 */
export const AuthHelloSchema: GenMessage<AuthHello> = /*@__PURE__*/
  messageDesc(file_luwu_v1_auth, 0);

/**
 * @generated from message luwu.v1.HostInfo
 */
export type HostInfo = Message<"luwu.v1.HostInfo"> & {
  /**
   * @generated from field: string hostname = 1;
   */
  hostname: string;

  /**
   * @generated from field: string os = 2;
   */
  os: string;

  /**
   * @generated from field: string arch = 3;
   */
  arch: string;

  /**
   * @generated from field: string version = 4;
   */
  version: string;

  /**
   * @generated from field: string tmux_version = 5;
   */
  tmuxVersion: string;

  /**
   * What the owner's plan lets this computer serve ("screen", "files").
   * Unset from older computers: everything. The computer enforces it; the
   * app only hides what isn't there.
   *
   * @generated from field: repeated string features = 6;
   */
  features: string[];

  /**
   * The agents a new window can start here (CreateWindow.preset), built-in
   * and the owner's own (DeepSeek and the like). Unset from computers older
   * than 0.2.12, which offer claude, codex, gemini and shell.
   *
   * @generated from field: repeated luwu.v1.AgentPreset agents = 7;
   */
  agents: AgentPreset[];
};

/**
 * Describes the message luwu.v1.HostInfo.
 * Use `create(HostInfoSchema)` to create a new message.
 */
export const HostInfoSchema: GenMessage<HostInfo> = /*@__PURE__*/
  messageDesc(file_luwu_v1_auth, 1);

/**
 * @generated from message luwu.v1.AgentPreset
 */
export type AgentPreset = Message<"luwu.v1.AgentPreset"> & {
  /**
   * claude, codex, gemini, opencode, deepseek, …
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * as shown: "Claude Code", "DeepSeek"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * installed, with every key it needs
   *
   * @generated from field: bool available = 3;
   */
  available: boolean;

  /**
   * the template a custom preset came from, for its icon
   *
   * @generated from field: string based = 4;
   */
  based: string;

  /**
   * agent mode (the phone's chat view) can run it: Claude Code and Codex, and presets on them
   *
   * @generated from field: bool chat = 5;
   */
  chat: boolean;
};

/**
 * Describes the message luwu.v1.AgentPreset.
 * Use `create(AgentPresetSchema)` to create a new message.
 */
export const AgentPresetSchema: GenMessage<AgentPreset> = /*@__PURE__*/
  messageDesc(file_luwu_v1_auth, 2);

/**
 * @generated from message luwu.v1.AuthResult
 */
export type AuthResult = Message<"luwu.v1.AuthResult"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: bool pending_local_approval = 3;
   */
  pendingLocalApproval: boolean;

  /**
   * @generated from field: luwu.v1.AuthHello hello = 4;
   */
  hello?: AuthHello | undefined;

  /**
   * @generated from field: luwu.v1.HostInfo host = 5;
   */
  host?: HostInfo | undefined;
};

/**
 * Describes the message luwu.v1.AuthResult.
 * Use `create(AuthResultSchema)` to create a new message.
 */
export const AuthResultSchema: GenMessage<AuthResult> = /*@__PURE__*/
  messageDesc(file_luwu_v1_auth, 3);

